import { render, staticRenderFns } from "./promotion-code-report.vue?vue&type=template&id=0238cf82&scoped=true"
import script from "./promotion-code-report.vue?vue&type=script&lang=js"
export * from "./promotion-code-report.vue?vue&type=script&lang=js"
import style0 from "./promotion-code-report.vue?vue&type=style&index=0&id=0238cf82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238cf82",
  null
  
)

export default component.exports